import React from 'react';
import { Field } from 'react-final-form';
import { TextFieldProps, FormFieldProps } from 'types/TextField';
import TextField from '../TextField';

function FormTextField( {
  as,
  rows,
  field,
  value,
  validate,
  label,
  placeholder,
  type,
  size,
  translateLabel = true,
  validateTranslateValues,
  classNames = {},
  onChange,
  showErrors = true,
  appendIcon,
  onClickAppendIcon,
  disabled,
  style,
  onKeyDown,
}: TextFieldProps & FormFieldProps ) {
  if ( field ) {
    return (
      <Field name={field} validate={validate}>
        {( { meta, input } ) => {
          const isInvalid = ( meta.touched && !!meta.error )
            || ( meta.touched && !meta.dirtySinceLastSubmit && !!meta.submitError );

          return (
            <TextField
              value={input.value}
              onChange={onChange}
              inputOnChange={input.onChange}
              label={label}
              translateLabel={translateLabel}
              placeholder={placeholder}
              type={type}
              as={as}
              rows={rows}
              size={size}
              validateTranslateValues={validateTranslateValues}
              classNames={classNames}
              showErrors={showErrors}
              appendIcon={appendIcon}
              isInvalid={isInvalid}
              meta={meta}
              disabled={disabled}
              style={style}
              onClickAppendIcon={onClickAppendIcon}
              onKeyDown={onKeyDown}
            />
          );
        }}
      </Field>
    );
  }

  return (
    <TextField
      value={value as string}
      onChange={onChange}
      label={label}
      translateLabel={translateLabel}
      placeholder={placeholder}
      type={type}
      size={size}
      validateTranslateValues={validateTranslateValues}
      classNames={classNames}
      showErrors={showErrors}
      appendIcon={appendIcon}
      onClickAppendIcon={onClickAppendIcon}
      onKeyDown={onKeyDown}
    />
  );
}

export default FormTextField;
